import Immutable from "immutable";
import { floatToMoney } from "lib/money";

import * as common from "lib/appserver/entityHeaders/common";

const School = new Immutable.Record({
  ...common.defaultProperties,
  name: undefined,
  emailAddress: undefined,
  websiteURL: undefined,
  phoneNumber: undefined,
  logoFilePath: undefined,
  isCashless: undefined,
  showVegPreference: undefined,
  isDinnersEnabled: undefined,
  isDinnerTopUpsEnabled: undefined,
  isClubTopUpsEnabled: undefined,
  defaultDinnerTopUpAmount: undefined,
  defaultClubTopUpAmount: undefined,
  paysafeAccountNumber: undefined,
  paymentProvider: undefined,
  externalCashlessName: undefined,
  isXodActive: undefined,
  isExternalTopUpEnabled: undefined,
  minimumPaymentAmount: undefined,
  isApplePayEnabled: undefined,
  isGooglePayEnabled: undefined
}, "School");

function buildSchoolFromAppserver(rawSchool) {
  return School({
    ...common.appserverAdapter(rawSchool),
    name: rawSchool.name,
    emailAddress: rawSchool.email_address,
    websiteURL: rawSchool.website_url,
    phoneNumber: rawSchool.phone_number,
    logoFilePath: rawSchool.logo_file_path,
    isCashless: rawSchool.enable_cashless_catering,
    showVegPreference: rawSchool.show_veg_meal_preference,
    isDinnersEnabled: !rawSchool.hide_dinner_top_ups,
    isDinnerTopUpsEnabled: !rawSchool.force_dinner_booking,
    isClubTopUpsEnabled: !rawSchool.hide_club_top_ups,
    defaultDinnerTopUpAmount: floatToMoney(rawSchool.default_dinner_topup_amount),
    defaultClubTopUpAmount: floatToMoney(rawSchool.default_club_topup_amount),
    paysafeAccountNumber: rawSchool.paysafe_account_number,
    paymentProvider: rawSchool.payment_provider,
    externalCashlessName: rawSchool.external_cashless_name,
    isXodActive: rawSchool.is_xod_active,
    isExternalTopUpEnabled: rawSchool.is_external_topup_enabled,
    minimumPaymentAmount: floatToMoney(rawSchool.minimum_online_amount),
    isApplePayEnabled: rawSchool.enable_apple_pay,
    isGooglePayEnabled: rawSchool.enable_google_pay
  });
}

School.fromAppserver = buildSchoolFromAppserver;
export default School;



// WEBPACK FOOTER //
// ./src/state/school_money/entities/School.js